import Content from 'components/Content';
import Header from 'components/Header/Header';
import './App.css'
import 'assets/styles/bootstrapOverride.css'

function App() {
  return (
    <div className="App">
      <Header />
      <Content />
    </div>
  );
}

export default App;
